module.exports = __webpack_public_path__ + "static/media/zheng10@3x.846ef10b.png";